import {useEffect,useContext} from 'react';

import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
  IonGrid,IonCol,IonRow ,IonButton,IonLabel,
  IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCardContent,
  IonItem,
  useIonToast,
  IonIcon,
  useIonModal} from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';

import {AppContext} from '../global';


import '../common/styles.css';

import styles from './Home.module.css';

import {useHistory, useLocation} from 'react-router';
import {useRestGet,logout} from '../hooks/AdminHttp';
import { logOutOutline, personOutline, refreshOutline } from 'ionicons/icons';
import UpdatePassword from '../modal/UpdatePassword';

const statistics = [
  { field: 'allDeviceCount', title: '设备统计', label: '所有设备' },
  { field: 'allUserCount', title: '用户统计', label: '所有用户' },
  { field: 'allClientCount', title: '客户端统计', label: '所有客户端（Client）' },
  { field: 'allDeviceConfigCount', title: '配置文件统计', label: '所有配置文件' },
  { field: 'allDeviceUpgradeKitCount', title: '设备升级包统计', label: '所有设备升级包' },
  { field: 'allOperatorCount', title: '运营商统计', label: '所有运营商' },
];

const Home: React.FC = () => {

  const {data,setData,status,setStatus} = useContext(AppContext);

  const history = useHistory();

  const [home,getHome] = useRestGet('/admin/rest/home');

  const [toastPresent,toastDismiss] = useIonToast();


  const [presentUpdatePassword, dismissUpdatePassword] = useIonModal(UpdatePassword, {
    email:data.email,
    role: data.role,
    onCloseClicked: ()=>{
      dismissUpdatePassword();
    }
  });

  useEffect(()=>{
    getHome();
  },[]);


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonMenuButton slot="start"/>
          <IonTitle>首页</IonTitle>
          <IonButtons slot="end">
          {data.role === 'root' && <IonButton aria-label="刷新统计" onClick={()=>getHome()}>
            <IonIcon slot="start" icon={refreshOutline} />
            <IonLabel>刷新统计</IonLabel>
          </IonButton>}
          <IonButton onClick={()=>{
            presentUpdatePassword();
          }}>
              <IonIcon slot="start" icon={personOutline} />
              <IonLabel>{data.email}[{data.role}]</IonLabel>
            </IonButton>

            <IonButton  onClick={()=>{
              logout(d=>{
                if (d.code == 200){
                  setData({...data,token:null});
                  setStatus({...status,login:false});
                  window.location.href="/";
                }else{
                  toastPresent(d.message);
                }
              });
            }}>
              <IonIcon slot="start" icon={logOutOutline} />
              <IonLabel>登出</IonLabel>
            </IonButton>
          </IonButtons>

        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>


      {
        data.role === 'root' && statistics.map(statistic => (
        <IonCard key={statistic.field}>
          <IonCardSubtitle className={styles.cardTitle}>{statistic.title}</IonCardSubtitle>
          <IonCardContent>
          
            <IonGrid className={styles.homeGrid}>
              <IonRow className={styles.homeRow}>

                <IonCol size="5" className={styles.homeCol}>
                  {statistic.label}
                </IonCol>
                <IonCol size="5">
                  {home[statistic.field] ?? '—'}
                </IonCol>
              </IonRow>
              
            </IonGrid>
          </IonCardContent>
        </IonCard>
        ))
      }

      </IonContent>
    </IonPage>
  );
};

export default Home;
